import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';

/**
 * List of URLs (or patterns) that should be excluded from retry logic in the HTTP interceptor.
 */
export const retryExclusions: (string | RegExp)[] = [
  'PdfResultImport/ImportPdf',
  EndpointConstants.ApiNtfNotification,
  /\/crm\/partners\/contacts\/?(?:\?.*)?$/i,
];
